const TYPE_USER_LABELS = {
    ALL: 'Tous les utilisateurs',
    CUSTOMER: 'Client uniquement',
    MECANICIEN: 'Vendeur uniquement',
};

const typeUsers = [
    {value:'ALL', label:'Tous les utilisateurs'},
    {value:'CUSTOMER', label:'Client'},
    {value:'MECANICIEN', label:'Vendeur'},
]

const documentTypes = [
    { value: 'CGV', label: 'Conditions Générales de Vente' },
    { value: 'CGA', label: "Conditions Générales d'Achat" },
]

const statutColors = {
    'BROUILLON': 'default',
    'PUBLIE': 'green',
    'ARCHIVE': 'orange',
}



export {
    TYPE_USER_LABELS,
    typeUsers,
    documentTypes,
    statutColors
}

// const handleTypeUserRender = (typeUser) => TYPE_USER_LABELS[typeUser] ?? '';
